function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 20 0 30 9.75 30 40 0 40"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "FYI-Document-Icons",
  transform: "translate(-216.000000, -331.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Google-Slide",
  transform: "translate(0.000000, 303.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-Main",
  transform: "translate(216.000000, 28.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#F5BA15",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6,17 L6,34 L24,34 L24,17 L6,17 Z M9,22 L21,22 L21,29 L9,29 L9,22 Z",
  id: "path5332",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  fill: "#FADC87",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  x: 20,
  y: 0,
  width: 10,
  height: 10
})))));

var SvgGooglePowerpoint = function SvgGooglePowerpoint(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGooglePowerpoint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google_powerpoint.405c1eba.svg";
export { ForwardRef as ReactComponent };